import React from 'react'
import ReactDOM from 'react-dom'
import TagManager from 'react-gtm-module'
import { Provider } from 'react-redux'
import store from './redux/store'

import './index.css'
import '@coreui/coreui/dist/css/coreui.min.css'

import App from './App'
const tagManagerArgs = {
  gtmId: 'G-VDP8KXHDMJ'
}

TagManager.initialize(tagManagerArgs)
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)
